module.exports = __webpack_public_path__ + "static/media/mp.c5eb7f23.svg";